const de = {
  "srv_general_unknown": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  "srv_general_network": "Netzwerkfehler. Bitte Verbindung prüfen.",
  "srv_general_timeout": "Zeitüberschreitung der Anfrage. Bitte erneut versuchen.",
  "srv_general_not_found": "Nicht gefunden",
  "srv_general_invalid_id": "Ungültige ID",
  "srv_general_invalid_json": "Ungültiges JSON",
  "srv_auth_admin_only": "Nur für Admins",
  "srv_auth_owner_only": "Nur für Kontoinhaber",
  "srv_auth_unauthorized": "Nicht autorisiert",
  "srv_auth_not_authenticated": "Nicht angemeldet",
  "srv_auth_invalid_token": "Ungültiger Token",
  "srv_auth_session_expired": "Kein Refresh-Token",
  "srv_auth_token_expired": "Token abgelaufen",
  "srv_auth_device_signed_out": "Dieses Gerät wurde abgemeldet",
  "srv_auth_invalid_login": "Ungültiger Benutzername/E-Mail oder Passwort",
  "srv_auth_wrong_password": "Aktuelles Passwort ist falsch",
  "srv_auth_email_already_exists": "E-Mail bereits registriert",
  "srv_auth_email_taken_other": "Diese E-Mail wird jetzt von einem anderen Konto verwendet",
  "srv_auth_same_email": "Das ist bereits deine E-Mail",
  "srv_auth_same_username": "Das ist bereits dein Benutzername",
  "srv_auth_username_taken": "Benutzername bereits vergeben",
  "srv_auth_username_invalid": "Benutzername muss 3–20 Buchstaben, Zahlen oder Unterstriche enthalten",
  "srv_auth_user_not_found": "Benutzer nicht gefunden",
  "srv_auth_password_mismatch": "Passwörter stimmen nicht überein",
  "srv_auth_password_weak": "Neues Passwort muss mindestens 8 Zeichen sowie einen Buchstaben und eine Zahl enthalten",
  "srv_auth_password_same": "Neues Passwort muss sich vom aktuellen Passwort unterscheiden",
  "srv_auth_rate_limited": "Zu viele Versuche. Später erneut versuchen.",
  "srv_auth_signup_rate_limited": "Zu viele Registrierungen aus diesem Netzwerk. Später erneut versuchen.",
  "srv_auth_verify_link_invalid": "Ungültiger oder bereits verwendeter Bestätigungslink",
  "srv_auth_verify_link_expired": "Bestätigungslink abgelaufen. Bitte einen neuen anfordern.",
  "srv_auth_email_already_verified": "E-Mail bereits bestätigt.",
  "srv_auth_verification_sent": "Bestätigungs-E-Mail gesendet.",
  "srv_auth_email_change_sent": "Bestätigungslink an die neue E-Mail gesendet. Bestätige ihn, um die Änderung abzuschließen.",
  "srv_auth_reset_link_invalid": "Ungültiger oder abgelaufener Zurücksetzungslink",
  "srv_auth_reset_sent": "Falls das Konto existiert, wurde ein Zurücksetzungslink gesendet.",
  "srv_auth_password_updated": "Passwort aktualisiert. Bitte mit dem neuen Passwort anmelden.",
  "srv_auth_password_changed": "Passwort geändert. Bitte auf deinen anderen Geräten erneut anmelden.",
  "srv_auth_signed_out_all": "Von allen Geräten abgemeldet",
  "srv_auth_signed_out_others": "Von allen anderen Geräten abgemeldet",
  "srv_auth_device_revoked": "Gerät abgemeldet",
  "srv_subscription_required": "Diese Funktion ist für Premium-Mitglieder",
  "srv_subscription_plan_unavailable": "Testplan ist nicht verfügbar.",
  "srv_subscription_order_not_found": "Bestellung nicht gefunden",
  "srv_payment_provider_unreachable": "Zahlungsanbieter nicht erreichbar. Erneut versuchen.",
  "srv_payment_invoice_failed": "Zahlungsanbieter konnte die Rechnung nicht erstellen. Erneut versuchen.",
  "srv_payment_not_configured": "Krypto-Zahlungsgateway ist noch nicht eingerichtet. Bitte NOWPayments API-Schlüssel hinzufügen.",
  "srv_payment_invalid_signature": "Ungültige Signatur",
  "srv_exchange_connection_not_found": "Verbindung nicht gefunden",
  "srv_exchange_unsupported": "Nicht unterstützte Exchange",
  "srv_exchange_unreachable": "Exchange vom Server aus nicht erreichbar",
  "srv_exchange_key_not_readonly": "Dieser API-Schlüssel hat Handels-/Auszahlungsrechte. Erstelle einen READ-ONLY-Schlüssel (Trade und Withdraw deaktivieren).",
  "srv_exchange_verify_first": "Verbindung vor Aktivierung des Live-Handels bestätigen",
  "srv_insufficient_balance": "Betrag übersteigt dein verfügbares Guthaben",
  "srv_trade_amount_positive": "Betrag muss größer als 0 sein",
  "srv_trade_invalid_withdrawal": "Ungültiger Auszahlungsbetrag",
  "srv_trade_bot_needs_tp_sl": "Bot benötigt sowohl Stop Loss als auch Take Profit",
  "srv_trade_no_position": "Keine offene Position zum Verkaufen",
  "srv_trade_position_not_found": "Position nicht gefunden",
  "srv_trade_symbol_required": "Symbol ist erforderlich",
  "srv_trade_invalid_symbol": "Ungültiges Symbol",
  "srv_trade_invalid_interval": "Ungültiges Intervall",
  "srv_trade_verify_email": "Bitte bestätige deine E-Mail, bevor du Trades eröffnest.",
  "srv_trade_verify_email_auto": "Bitte bestätige deine E-Mail, bevor du Auto-Handel aktivierst.",
  "srv_trade_demo_min": "Mindest-Demoguthaben ist 100",
  "srv_trade_demo_max": "Demoguthaben ist zu hoch (max. 10,000,000)",
  "srv_trade_leverage_confirm": "Hebel über 20x erfordert doppelte Bestätigung",
  "srv_trade_high_risk_confirm": "Risiko über 15% erfordert High-Risk-Bestätigung",
  "srv_trade_high_liquidation_risk": "Hohes Liquidationsrisiko",
  "srv_trade_no_fee": "Keine Gebühr (7+ Tage gehalten).",
  "srv_insufficient_data": "Nicht genügend Kerzendaten für diesen Backtest",
  "srv_notification_not_found": "Benachrichtigung nicht gefunden",
  "srv_nft_image_failed": "Bildgenerierung fehlgeschlagen",
  "ntf_cloud_enabled": "Cloud-Trading aktiviert — Bot läuft 24/7.",
  "ntf_cloud_disabled": "Cloud-Trading deaktiviert.",
  "srv_trade_no_price": "Kein Preis für {symbol} verfügbar",
  "srv_trade_risk_lock": "Risikolimit: max. {pct}% des Guthabens pro Trade",
  "srv_trade_max_leverage": "Maximaler Hebel für {symbol} ist {max}x",
  "srv_trade_risk_range": "Risiko für {symbol} muss zwischen 1% und {max}% liegen",
  "srv_payment_unsupported_currency": "Nicht unterstützte Währung. Wähle eine aus: {list}",
  "srv_exchange_unsupported_named": "Nicht unterstützte Börse: {name}",
  "srv_auth_username_cooldown": "Benutzername kann in {days} Tag(en) wieder geändert werden",
  "srv_exchange_connection_error": "Verbindungsfehler: {error}",
  "srv_trade_early_fee": "Frühabhebungsgebühr von 5% ({fee}) angewendet.",
  "ntf_risk_drawdown": "Max. Drawdown von {dd}% hat das Limit von {limit}% erreicht. Alle Positionen geschlossen. Bot angehalten.",
  "ntf_risk_losses": "{count} Verlusttrades in Folge. Bot angehalten. Zum Fortsetzen bestätigen.",
  "ntf_cooldown": "Abkühlphase nach {count} Verlusttrades in Folge — neue Einstiege für {minutes} Min. pausiert.",
  "ntf_trade_opened": "Trade eröffnet: {symbol} {timeframe} · Score {score} · {leverage}",
  "ntf_nft_opened": "NFT-Position eröffnet (Demo): {name}",
  "ntf_nft_closed": "NFT-Position geschlossen (Demo): P&L {pnl}",
  "ntf_trade_closed": "{reason}: {symbol} geschlossen · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · Score {score}. Einstieg ${entry} / TP ${tp} / SL ${sl}. Nur zur Information — keine Finanzberatung.",
  "app_name": "FIREBIRD AI",
  "tagline": "KI-Krypto- & NFT-Trading",
  "login": "Anmelden",
  "register": "Registrieren",
  "logout": "Abmelden",
  "email": "E-Mail",
  "password": "Passwort",
  "name": "Name",
  "welcome_back": "Willkommen zurück, Trader",
  "create_account": "Erstelle dein Konto",
  "no_account": "Noch kein Konto?",
  "have_account": "Du hast bereits ein Konto?",
  "account_created": "Konto erstellt — $100 Demo bereit",
  "loading": "Wird geladen…",
  "demo_mode": "Demo-Modus",
  "demo_balance": "Demo-Guthaben",
  "nav_dashboard": "Übersicht",
  "nav_charts": "Live-Charts",
  "nav_signals": "KI-Signale",
  "nav_autotrade": "Auto-Handel",
  "nav_manual": "Manueller Handel",
  "nav_scanner": "Memecoin-Scanner",
  "nav_backtest": "5×5-Backtest",
  "nav_positions": "Positionen & Berichte",
  "nav_nft": "NFT-Kollektion",
  "nav_assistant": "KI-Assistent",
  "nav_settings": "Börse & Einstellungen",
  "nav_subscription": "Premium-Tarif",
  "subscription_subtitle": "Schalte Premium-Trading-Intelligenz frei — bezahle mit Krypto.",
  "current_plan": "Aktueller Tarif",
  "premium": "Premium",
  "free_plan": "Kostenloser Tarif",
  "renews_on": "Verlängert sich am",
  "active": "Aktiv",
  "best_value": "Bestes Angebot",
  "plan_monthly": "Monatlich",
  "plan_annual": "Jährlich",
  "plan_test": "Test",
  "days": "Tage",
  "pay_with_crypto": "Mit Krypto bezahlen",
  "opening_checkout": "Kasse wird geöffnet…",
  "gateway_not_ready": "Das Krypto-Zahlungsgateway ist noch nicht konfiguriert. Der Premium-Checkout wird aktiviert, sobald die NOWPayments-API-Schlüssel hinzugefügt sind.",
  "premium_only": "Nur Premium",
  "premium_gate_desc": "Diese Funktion gehört zu FireBird Premium. Upgrade, um alle KI-Signale, Auto-Handel und den Chancen-Scanner freizuschalten.",
  "go_premium": "Premium holen",
  "billing_history": "Abrechnungsverlauf",
  "no_invoices": "Noch keine Rechnungen. Deine Krypto-Zahlungen erscheinen hier.",
  "date": "Datum",
  "plan_col": "Tarif",
  "amount_col": "Betrag",
  "status_col": "Status",
  "view_invoice": "Rechnung ansehen",
  "check_status": "Zahlungsstatus prüfen",
  "checking": "Wird geprüft…",
  "payment_still_pending": "Zahlung noch nicht bestätigt. Wir prüfen automatisch weiter.",
  "status_paid": "Bezahlt",
  "status_created": "Ausstehend",
  "status_partially_paid": "Teilweise bezahlt",
  "status_expired": "Abgelaufen",
  "status_failed": "Fehlgeschlagen",
  "status_refunded": "Erstattet",
  "status_cancelled": "Storniert",
  "status_canceled": "Storniert",
  "payment_processing": "Zahlung erkannt — dein Premium-Tarif wird aktiviert…",
  "payment_success": "Premium aktiviert. Willkommen an Bord!",
  "payment_cancelled": "Zahlung storniert.",
  "payment_error": "Checkout konnte nicht gestartet werden. Bitte versuche es erneut.",
  "popup_blocked": "Der Checkout ist bereit. Falls sich kein neuer Tab geöffnet hat, nutze den Link unten.",
  "checkout_opened_hint": "Der Checkout wurde in einem neuen Tab geöffnet. Nicht gesehen?",
  "open_checkout": "Checkout öffnen",
  "pay_currency_label": "Bezahlen mit",
  "pay_currency_hint": "Wir akzeptieren USDC auf Solana und BNB auf BSC. Dein gewähltes Asset wird beim Checkout fixiert.",
  "feat_signals": "Alle KI-Signale (Krypto, Shitcoins, NFT)",
  "feat_autotrade": "Auto-Handel mit Risikomanagement",
  "feat_scanner": "Memecoin- & Chancen-Scanner",
  "feat_alerts": "Intelligente E-Mail-Benachrichtigungen",
  "feat_priority": "Priorisierte Signalzustellung",
  "feat_save": "2 Monate gratis gegenüber monatlicher Zahlung",
  "feat_test_quick": "Einmaliger $1-Test — prüft den echten Zahlungsablauf",
  "demo_account_settings": "Demo-Konto-Einstellungen",
  "demo_settings_desc": "Lege ein eigenes Demo-Guthaben fest und setze dein Paper-Trading-Konto zurück. Das betrifft nur Demo-Daten — dein Abo und echter Handel bleiben unberührt.",
  "custom_demo_balance": "Eigenes Demo-Guthaben (USDC)",
  "demo_min_hint": "Standard 500 · Minimum 100",
  "reset_demo_account": "Demo-Konto zurücksetzen",
  "reset_demo_confirm_title": "Demo-Konto zurücksetzen?",
  "reset_demo_confirm_desc": "Dein Demo-Guthaben wird auf ${bal} gesetzt, alle Demo-Trades und der G/V-Verlauf werden gelöscht und Drawdown-, Stopp- und Abkühlstatus zurückgesetzt. Das kann nicht rückgängig gemacht werden. Dein Abo und deine Live-Daten sind nicht betroffen.",
  "demo_reset_done": "Demo-Konto zurückgesetzt — Guthaben auf ${bal} gesetzt",
  "demo_min_balance_error": "Das minimale Demo-Guthaben beträgt 100",
  "nav_guide": "Anfängerleitfaden",
  "owner_console": "Eigentümer-Konsole",
  "total_value": "Gesamtwert",
  "cash": "Bargeld",
  "holdings": "Bestände",
  "unrealized_pnl": "Nicht realisierter PnL",
  "top_signals": "Top-KI-Signale",
  "market_overview": "Marktübersicht",
  "whale_activity": "Wale & Smart Money",
  "market_pulse": "Marktpuls",
  "news_up": "{name} steigt in 24 Std. um {pct}%",
  "news_down": "{name} fällt in 24 Std. um {pct}%",
  "kind_cex": "CEX",
  "kind_iranian_cex": "Iranische CEX",
  "kind_dex": "DEX",
  "price": "Preis",
  "change_24h": "24 Std.",
  "score": "Bewertung",
  "action": "Aktion",
  "buy": "Kaufen",
  "sell": "Verkaufen",
  "hold": "Halten",
  "timeframe": "Zeitrahmen",
  "symbol": "Symbol",
  "amount_usd": "Betrag (USD)",
  "open_position": "Position eröffnen",
  "close": "Schließen",
  "no_positions": "Keine offenen Positionen",
  "entry": "Einstieg",
  "current": "Aktuell",
  "exit": "Ausstieg",
  "reason": "Grund",
  "pnl": "PnL",
  "win_rate": "Trefferquote",
  "total_trades": "Trades gesamt",
  "total_pnl": "PnL gesamt",
  "wl": "G / V",
  "open_label": "Offen",
  "run_backtest": "Backtest starten",
  "running": "Läuft…",
  "bt_subtitle": "Strategie getestet über 5 historische Fenster pro Zeitrahmen.",
  "window_results": "Fensterergebnisse",
  "window": "Fenster",
  "trades": "Handel",
  "return_label": "Rendite",
  "max_drawdown": "Max. Drawdown",
  "auto_trade_on": "Auto-Handel aktiv",
  "auto_trade_off": "Auto-Handel aus",
  "enable_autotrade": "Auto-Handel aktivieren (Demo)",
  "reset_demo": "Demo zurücksetzen ($100)",
  "activity_log": "Aktivitätsprotokoll",
  "waiting_signals": "Warte auf Signale…",
  "enable_to_start": "Aktiviere Auto-Handel zum Starten",
  "reauthorize_bot": "Bot neu autorisieren",
  "leverage": "Hebel",
  "high_leverage_warning": "Hoher Hebel — du kannst deine gesamte Margin verlieren (Liquidation).",
  "bot_description": "Der Bot scannt alle Coins auf 15m / 1h / 4h, steigt beim besten Signal ein (2:1 Chance-Risiko, Stopp erforderlich) und verwaltet Positionen im Demo-Modus mit Trailing-Take-Profit.",
  "rule_rr": "Chance:Risiko 2:1 (Stopp erforderlich)",
  "rule_max_concurrent": "Max. 2 gleichzeitige automatische Trades",
  "rule_leverage": "Auto-Hebel ≤ 10x · Manuell ≤ 50x",
  "rule_circuit": "Schutzschalter bei 20% Drawdown",
  "rule_halt": "Stopp nach 5 Verlusten",
  "rule_scan": "Scannt alle Coins & Zeitrahmen",
  "rule_entry": "Einstiegs-Score ≥ {score} auf {tfs}",
  "rule_cooldown": "{min} Min. Abkühlphase nach {losses} Verlusten",
  "risk_status": "Risikostatus",
  "risk_mode_active": "Aktiv",
  "risk_mode_halted": "Gestoppt",
  "consecutive_losses_label": "Aufeinanderfolgende Verluste",
  "drawdown_label": "Rückgang",
  "open_positions_label": "Offene Positionen",
  "max_concurrent_reached": "Maximale Anzahl gleichzeitiger Trades erreicht.",
  "bot_reauthorized": "Bot neu autorisiert. Du kannst Auto-Handel wieder aktivieren.",
  "cloud_trading": "Cloud-Trading",
  "enable_cloud": "Cloud-Trading aktivieren",
  "disable_cloud": "Cloud-Trading deaktivieren",
  "cloud_status": "Cloud-Status",
  "cloud_on": "Läuft 24/7",
  "cloud_off": "Aus",
  "cloud_desc": "Der Bot läuft rund um die Uhr auf unseren Servern, auch wenn dein Gerät ausgeschaltet ist.",
  "notifications": "Benachrichtigungen",
  "no_notifications": "Noch keine Benachrichtigungen",
  "mark_all_read": "Alle als gelesen markieren",
  "connect_exchange": "Börse verbinden",
  "api_key": "API-Schlüssel",
  "api_secret": "API-Secret",
  "api_key_optional": "API-Schlüssel (optional für öffentliche Preise)",
  "connect": "Verbinden",
  "test": "Testen",
  "remove": "Entfernen",
  "verified": "Verifiziert",
  "not_verified": "Nicht verifiziert",
  "connected_exchanges": "Verbundene Börsen",
  "aggregated_balances": "Guthaben · Alle Börsen",
  "aggregated_prices": "Live-Preise · Alle Börsen",
  "no_connections": "Noch keine Börsen verbunden.",
  "connect_wallet": "Wallet verbinden",
  "wallet_connected": "Wallet verbunden",
  "wallet_note": "Non-Custodial — wir speichern niemals deine privaten Schlüssel.",
  "wallet_security": "Wallet & Sicherheit",
  "wallet_never_ask": "Wir fragen niemals nach deinem privaten Schlüssel oder deiner Seed-Phrase.",
  "disconnect_wallet": "Wallet trennen",
  "switch_chain": "Netzwerk wechseln",
  "native_balance": "Natives Guthaben",
  "wallet_chain": "Netzwerk",
  "dex_onchain": "DEX (On-Chain)",
  "sign_in_wallet": "Mit Wallet anmelden",
  "waiting_signature": "Warte auf Wallet-Signatur…",
  "dex_demo_note": "Du signierst mit deiner eigenen Wallet — Schlüssel verlassen nie dein Gerät.",
  "view_on_explorer": "Im Explorer ansehen",
  "wallet_required_dex": "Verbinde deine Wallet, um On-Chain zu handeln.",
  "tx_pending": "Transaktion ausstehend…",
  "tx_confirmed": "Transaktion bestätigt",
  "tx_failed": "Transaktion fehlgeschlagen",
  "connected_label": "Verbunden",
  "not_connected_label": "Nicht verbunden",
  "copy_address": "Adresse kopieren",
  "readonly_warning": "Erstelle deinen API-Schlüssel mit NUR-LESE-Rechten. Deaktiviere Auszahlung und Handel.",
  "cex_security_notice": "Wir speichern NIEMALS deine privaten Schlüssel und fordern keine Auszahlungsrechte an.",
  "api_passphrase_optional": "Passphrase (optional)",
  "read_only_label": "Nur Lesen",
  "how_to_create_key": "So erstellst du einen Nur-Lese-Schlüssel",
  "connected_wallets": "Verbundene Wallets",
  "no_wallet_connected": "Keine Wallet verbunden.",
  "no_exchange_linked": "Keine Börse verknüpft.",
  "smart_contract_allowances": "Smart-Contract-Freigaben",
  "no_allowances": "Keine aktiven Freigaben.",
  "revoke": "Widerrufen",
  "max_spend": "Max. Ausgabe",
  "link_readonly_hint": "Nutze das Panel „Börse verbinden“, um einen Nur-Lese-Schlüssel zu verknüpfen.",
  "vpn_notice": "Dieser Marktplatz erfordert in manchen Regionen möglicherweise ein VPN.",
  "ir_friendly": "Iran-tauglich",
  "best_price": "Bester Preis",
  "marketplace_listings": "Marktplatz-Angebote",
  "tab_opps": "Chancen",
  "opportunities": "Chancen",
  "high_opportunity": "Hohe Chance",
  "alerts_triggered_today": "Alarme heute ausgelöst",
  "score_range": "Score-Bereich",
  "timeframe_label": "Zeitrahmen",
  "direction_label": "Richtung",
  "risk_disclaimer_title": "Risikohinweis",
  "risk_disclaimer": "Signale dienen nur zur Information. KEINE Anlageberatung. 98% der Shitcoins scheitern. Nutze immer einen Stop Loss. Riskiere nie mehr als 1-5% pro Trade.",
  "no_opportunities": "Derzeit keine Chancen. Der Scanner läuft alle 5 Minuten.",
  "alerts_title": "Alarme",
  "enable_scanner": "Auto-Scanner aktivieren",
  "min_score_label": "Mindest-Score",
  "monitor_timeframes": "Zu überwachende Zeitrahmen",
  "max_alerts_day": "Max. Alarme pro Tag",
  "notify_method_label": "Benachrichtigungsart",
  "notify_in_app": "Nur in der App",
  "notify_in_app_email": "In der App + E-Mail",
  "alert_history_title": "Alarmverlauf",
  "no_alert_history": "Noch keine Alarme.",
  "nft_markets": "NFT-Marktplätze",
  "iran_friendly": "Iran-tauglich",
  "key_security_note": "Schlüssel werden auf dem Server verschlüsselt und nie in deinem Browser gespeichert.",
  "exchange": "Börse",
  "no_balances": "Keine Guthaben (füge API-Schlüssel hinzu, um Live-Guthaben zu laden).",
  "safety": "Sicherheit",
  "opportunity": "Chance",
  "holders": "Holder",
  "verdict": "Urteil",
  "coin": "Coin",
  "chain": "Blockchain",
  "scanning": "Scanne…",
  "scanner_subtitle": "Kuratierte Memecoins mit handelbarer Liquidität (Score ≥ 75). Keine unbekannten oder betrügerischen Token.",
  "safety_note": "Sicherheit = Liquiditätssperre + Mint-Verzicht + Holder-Verteilung (indikativ, keine Anlageberatung).",
  "ask_ai": "Frag Firebird AI...",
  "send": "Senden",
  "chat": "Chat",
  "ai_empty": "Frag nach einem Coin, Zeitrahmen oder einer Strategie. Nichts davon ist Anlageberatung.",
  "ai_thinking": "Firebird AI denkt nach…",
  "ai_error": "Entschuldigung, ich konnte gerade nicht antworten.",
  "score_coin": "Diesen Coin bewerten",
  "any_coin_symbol": "Beliebiges Coin-Symbol",
  "analyzing": "Analysiere…",
  "entry_strategy": "Einstieg",
  "exit_strategy": "Ausstieg",
  "risk": "Risiko",
  "signals_subtitle": "KI + technisches Scoring über alle Coins",
  "momentum": "Momentum",
  "simulated_feed": "simulierter Feed",
  "collection": "Firebird-555-Kollektion",
  "nft_subtitle": "Firebird / Phoenix — 555 Items · 6 legendäre Raritäten · jedes mit seiner eigenen Geschichte von Zerstörung und Wiedergeburt",
  "rares": "Legendäre Raritäten",
  "floor_price": "Floor-Preis",
  "minted": "Gemintet",
  "total_supply": "Gesamtangebot",
  "rarity": "Seltenheit",
  "bt_download": "Herunterladen",
  "bt_stop_loss": "Stop-Loss (TP = 2× SL)",
  "bt_min_score": "Mindestsignal-Score",
  "bt_share": "Teilen",
  "bt_history": "Gespeicherte Backtest-Läufe",
  "bt_card_saved": "Ergebnis-Karte heruntergeladen",
  "bt_compare_tf": "Zeitrahmen vergleichen",
  "bt_best": "BESTE",
  "bt_worst": "SCHLECHTESTE",
  "bt_run_all": "Alle Coins ausführen",
  "bt_by_section": "Ergebnisse nach Bereich",
  "bt_per_coin": "Ergebnisse pro Coin",
  "bt_avg_return": "Durchschn. Rendite",
  "bt_skipped": "Übersprungen (nicht genügend Daten)",
  "bt_sec_major": "Hauptwerte",
  "bt_sec_shitcoin": "Shitcoin",
  "bt_sec_meme": "Meme",
  "bt_sec_nft": "NFT-Token",
  "bt_sec_other": "Andere",
  "bt_data_live": "LIVE-Marktdaten",
  "bt_data_simulated": "SIMULIERTE Daten (Live-Marktdaten nicht verfügbar)",
  "risk_per_trade": "Risiko pro Trade",
  "max_amount": "Max.",
  "tier_major": "Hauptwerte",
  "tier_mid": "Mid-Cap",
  "tier_meme": "Meme/Pump",
  "high_risk_ack": "Ich verstehe, dass dies ein Trade mit hohem Risiko ist (über 15% meines Guthabens).",
  "lev_warn_yellow": "Hohes Liquidationsrisiko",
  "lev_warn_red": "Extremer Hebel — sehr hohes Liquidationsrisiko. Doppelte Bestätigung erforderlich.",
  "lev_ack": "Ich verstehe, dass ich meine gesamte Margin verlieren kann.",
  "lev_confirm_again": "Extremer Hebel: Zum Bestätigen erneut drücken.",
  "confirm_again": "Erneut bestätigen",
  "high_risk_required": "Bitte bestätige das hohe Risiko.",
  "lev_ack_required": "Bitte bestätige die Warnung zum extremen Hebel.",
  "trait_element": "Element",
  "trait_aura": "Aura",
  "trait_background": "Hintergrund",
  "prev": "Zurück",
  "next": "Weiter",
  "all": "Alle",
  "save": "Speichern",
  "risk_lock": "Risikosperre",
  "max_position": "Max. Position %",
  "trailing_stop": "Nachziehender Stop %",
  "take_profit": "Gewinnmitnahme %",
  "stop_loss": "Verlustbegrenzung %",
  "risk_strategy": "Risiko & Strategie",
  "exchanges": "Börsenverbindungen",
  "connected": "Verbunden",
  "disconnected": "Nicht verbunden",
  "withdraw_demo_wallet": "Auszahlen (Demo-Wallet)",
  "withdraw_fee_note": "Eine Auszahlung innerhalb von 7 Tagen nach deiner letzten Einzahlung unterliegt einer Gebühr von 5% für vorzeitige Auszahlung (Anteil des Eigentümers).",
  "withdraw": "Auszahlen",
  "trade_history": "Handelsverlauf",
  "no_closed_trades": "Noch keine abgeschlossenen Trades",
  "owner_subtitle": "Nur-Ansicht-Performance aller Nutzer · Provisionsbuch (2% pro profitablem Trade, wöchentliche Abrechnung · 5% Gebühr bei vorzeitiger Auszahlung)",
  "total_users": "Nutzer gesamt",
  "total_commission": "Provision gesamt",
  "this_week": "Diese Woche",
  "total_volume": "Gesamtvolumen",
  "all_time": "insgesamt",
  "settles_weekly": "wöchentliche Abrechnung",
  "commission_breakdown": "Provisionsübersicht",
  "from_trade_profits": "Aus Handelsgewinnen (2%)",
  "from_withdrawal_fees": "Aus Gebühren für vorzeitige Auszahlung (5%)",
  "owner_rate": "Satz des Eigentümers",
  "settlement": "Abrechnung",
  "early_exit_fee": "Gebühr für vorzeitigen Ausstieg",
  "weekly": "Wöchentlich",
  "daily_accrual": "Tägliche Abgrenzung",
  "no_commission_yet": "Noch keine Provision — sie entsteht bei profitablen Trades.",
  "users_performance": "Nutzer-Performance (nur Ansicht)",
  "col_user": "Nutzer",
  "col_role": "Rolle",
  "col_joined": "Beigetreten",
  "col_volume": "Volumen",
  "col_balance": "Guthaben",
  "role_owner": "Eigentümer",
  "role_user": "Nutzer",
  "guide_intro": "Willkommen bei Firebird AI Trade. Folge diesen Schritten, um sicher zu starten.",
  "guide_step": "Schritt",
  "guide1_title": "Demo-Modus ist aktiv",
  "guide1_desc": "Du startest mit $100 Demo-Guthaben. Echtes Geld wird erst verwendet, wenn du den Live-Handel ausdrücklich mit deinen eigenen sicheren Schlüsseln aktivierst.",
  "guide2_title": "Dashboard ansehen",
  "guide2_desc": "Portfoliowert, Top-KI-Signale, Marktübersicht, Walaktivität und Marktpuls an einem Ort.",
  "guide3_title": "KI-Signale prüfen",
  "guide3_desc": "Coins werden von 0-100 bewertet, anhand von RSI, SMA-Kreuzungen und Momentum über mehrere Zeitrahmen.",
  "guide4_title": "KI-Assistenten fragen",
  "guide4_desc": "Erhalte einen Coin-Score mit Einstiegs-/Ausstiegsstrategie und Risikohinweisen von Firebird AI Core (GPT-5.6).",
  "guide5_title": "Auto-Handel testen (Demo)",
  "guide5_desc": "Lass den Bot bei starken Signalen KAUF-Positionen eröffnen und per Trailing Stop / Take-Profit verwalten.",
  "guide6_title": "Memecoins scannen",
  "guide6_desc": "Es werden nur handelbare Memecoins mit hohen Sicherheits-Scores gezeigt — keine unbekannten oder betrügerischen Token.",
  "guide7_title": "Firebird-555-NFTs entdecken",
  "guide7_desc": "Stöbere in der Phoenix-Kollektion mit 555 Items und 6 legendären Raritäten.",
  "disclaimer": "Demo-/Sandbox-Modus. Nichts hier ist Anlageberatung. Kein System kann zukünftige Trefferquoten garantieren.",
  "src_manual": "Manuell",
  "src_auto": "Automatisch",
  "tier_legendary": "Legendär",
  "tier_epic": "Episch",
  "tier_rare": "Selten",
  "tier_common": "Häufig",
  "verdict_tradeable": "Handelbar",
  "verdict_watch": "Beobachten",
  "pressure_accumulation": "Akkumulation",
  "pressure_distribution": "Verteilung",
  "reason_take_profit": "Gewinnmitnahme",
  "reason_liquidation": "Liquidation",
  "reason_stop_loss": "Verlustbegrenzung",
  "reason_trailing_take_profit": "Nachziehende Gewinnmitnahme",
  "reason_trailing_stop": "Nachziehender Stop",
  "reason_signal_flip": "Signalwechsel",
  "welcome": "Willkommen",
  "trader": "Trader",
  "live": "Live",
  "verify_email_banner": "Bestätige deine E-Mail, um Trades zu eröffnen. Den Bestätigungslink findest du in deinem Posteingang.",
  "resend": "Erneut senden",
  "verification_sent": "Bestätigungs-E-Mail gesendet",
  "could_not_resend": "Erneutes Senden fehlgeschlagen",
  "search_coin_placeholder": "Suche einen Coin (z. B. BTC, PEPE, ARB)",
  "add_to_watchlist": "Zur Watchlist hinzufügen",
  "free_balance": "Freies Guthaben",
  "in_positions": "In Positionen",
  "total_equity": "Gesamtkapital",
  "watchlist": "Beobachtungsliste",
  "watchlist_empty": "Noch keine Coins — suche und tippe auf +, um hinzuzufügen.",
  "high_exposure": "Du nutzt {percent}% deines freien Guthabens — hohes Exposure.",
  "advanced_tpsl": "Erweitertes TP / SL",
  "entry_optional": "Einstieg (optional — Standard ist Markt)",
  "market": "Markt",
  "take_profit_price": "Take-Profit-Preis",
  "stop_loss_price": "Stop-Loss-Preis",
  "tp_example": "z. B. 72000",
  "sl_example": "z. B. 66000",
  "if_tp_hits": "Wenn TP erreicht wird",
  "if_sl_hits": "Wenn SL erreicht wird",
  "pnl_preview_note": "Basierend auf ${amount} Margin × {leverage}x. Linien im Chart eingezeichnet →",
  "clear_tpsl": "TP/SL löschen",
  "one_tap_trade": "One-Tap-Trade",
  "tp_short": "TP",
  "sl_short": "SL",
  "auto_signals": "Auto-Signale",
  "add_token_placeholder": "Beliebigen Token hinzufügen (z. B. ARB, OP, TIA)",
  "analyze": "Analysieren",
  "analyzing_on": "Analysiere {symbol} auf {tf}…",
  "tap_to_load": "Tippen, um im Chart zu laden →",
  "scanning_market": "Markt wird gescannt…",
  "no_signals": "Noch keine Signale.",
  "money_depth": "Geldfluss",
  "sr_zones": "S/R-Zonen",
  "bot_analysis": "Bot-Analyse",
  "confidence": "Konfidenz",
  "reasoning": "Begründung",
  "tp_label": "Take Profit",
  "sl_label": "Stop Loss",
  "risk_reward": "Risiko : Ertrag",
  "levels_from_position": "Live-Levels deiner offenen Position",
  "levels_suggested": "Vorgeschlagene Levels · keine Anlageberatung",
  "toast_opened": "{symbol}-Position {leverage}x eröffnet",
  "toast_closed": "{symbol} geschlossen · PnL ${pnl}",
  "toast_closed_pnl": "Geschlossen · PnL ${pnl}",
  "ago_s": "vor {n} Sek.",
  "ago_m": "vor {n} Min.",
  "ago_h": "vor {n} Std.",
  "ago_d": "vor {n} Tg.",
  "in_label": "Zufluss",
  "out_label": "Abfluss",
  "confirm_reveal_email": "E-Mail dieses Nutzers anzeigen? E-Mails sind privat — nur bei Bedarf ansehen.",
  "view_email_private": "E-Mail anzeigen (privat)",
  "display_name_updated": "Anzeigename aktualisiert",
  "change_email_sent": "Bestätigungslink an die neue E-Mail gesendet",
  "username_updated": "Benutzername aktualisiert",
  "password_changed": "Passwort geändert. Melde dich auf deinen anderen Geräten erneut an.",
  "confirm_logout_all": "Auf allen Geräten abmelden? Du musst dich danach erneut anmelden.",
  "no_wallet": "Keine Wallet-Erweiterung erkannt (MetaMask/WalletConnect).",
  "wallet_rejected": "Wallet-Verbindung abgelehnt.",
  "profile_security": "Profil & Sicherheit",
  "display_name": "Anzeigename",
  "display_name_optional": "Anzeigename (optional)",
  "edit": "Bearbeiten",
  "cancel": "Abbrechen",
  "change": "Ändern",
  "in_days": "In {days} Tg.",
  "username_label": "Benutzername",
  "username_hint": "3-20 Buchstaben, Zahlen oder Unterstrich. Alle 30 Tage änderbar.",
  "username_example": "z. B. arash_king",
  "email_private": "E-Mail (privat)",
  "change_email": "E-Mail ändern",
  "unverified": "Nicht verifiziert",
  "resend_verification": "Verifizierung erneut senden",
  "new_email": "Neue E-Mail",
  "current_password": "Aktuelles Passwort",
  "new_password": "Neues Passwort",
  "confirm_new_password": "Neues Passwort bestätigen",
  "send_verification_new": "Verifizierung an neue E-Mail senden",
  "change_email_hint": "Du bestätigst über einen Link an die neue E-Mail und meldest dich danach erneut an.",
  "email_private_hint": "Deine E-Mail wird nie öffentlich angezeigt. Nur du siehst sie hier.",
  "sessions": "Sitzungen",
  "logout_all_devices": "Von allen Geräten abmelden",
  "change_password": "Passwort ändern",
  "pw_hint": "Mind. 8 Zeichen, ein Buchstabe und eine Zahl.",
  "update_password": "Passwort aktualisieren",
  "coin_example_placeholder": "z. B. BTC, PEPE, TAO...",
  "username_or_email": "Benutzername oder E-Mail",
  "forgot_password_q": "Passwort vergessen?",
  "invalid_email": "Gib eine gültige E-Mail ein",
  "pw_mismatch": "Passwörter stimmen nicht überein",
  "username_hint_short": "3-20 Buchstaben, Zahlen oder Unterstrich",
  "account_created_verify": "Konto erstellt! Prüfe deine E-Mail, um dein Konto zu verifizieren.",
  "confirm_password_label": "Passwort bestätigen",
  "missing_verify_token": "Verifizierungs-Token fehlt.",
  "email_verified_msg": "E-Mail verifiziert!",
  "verification_failed": "Verifizierung fehlgeschlagen.",
  "verifying_email": "E-Mail wird verifiziert…",
  "email_verified_title": "E-Mail verifiziert",
  "go_to_login": "Zum Login",
  "verification_failed_title": "Verifizierung fehlgeschlagen",
  "verify_expired_hint": "Link abgelaufen? Melde dich an und nutze „Verifizierung erneut senden“ in den Einstellungen.",
  "back_to_login": "← Zurück zum Login",
  "forgot_password": "Passwort vergessen",
  "forgot_subtitle": "Gib deinen Benutzernamen oder deine E-Mail ein, und wir senden dir einen Link zum Zurücksetzen.",
  "forgot_sent_toast": "Falls das Konto existiert, wurde ein Link zum Zurücksetzen gesendet.",
  "forgot_sent_full": "Falls das Konto existiert, wurde ein Link zum Zurücksetzen gesendet. Prüfe deine E-Mail (15 Minuten gültig).",
  "send_reset_link": "Link zum Zurücksetzen senden",
  "remembered_it": "Wieder eingefallen?",
  "missing_reset_token": "Reset-Token fehlt. Nutze den Link aus deiner E-Mail.",
  "pw_requirement": "Das Passwort muss mindestens 8 Zeichen lang sein und einen Buchstaben sowie eine Zahl enthalten",
  "password_updated": "Passwort aktualisiert.",
  "reset_password": "Passwort zurücksetzen",
  "reset_subtitle": "Wähle ein neues Passwort für dein Konto.",
  "reset_invalid": "Ungültiger oder fehlender Reset-Link. Fordere einen neuen an.",
  "request_reset_link": "Reset-Link anfordern",
  "new_password_label": "Neues Passwort",
  "pw_hint2": "Mindestens 8 Zeichen, mit einem Buchstaben und einer Zahl.",
  "update_password_btn": "Passwort aktualisieren",
  "bullish": "Bullisch",
  "bearish": "Bärisch",
  "inflow": "Zufluss",
  "outflow": "Abfluss",
  "volume_up": "Volumen steigt",
  "volume_down": "Volumen sinkt",
  "money_flow_mfi": "Geldfluss (MFI 14)",
  "flow_overbought": "Überkauft",
  "flow_oversold": "Überverkauft",
  "flow_bullish": "Bullischer Zufluss",
  "flow_bearish": "Bärischer Abfluss",
  "support": "Unterstützung",
  "resistance": "Widerstand",
  "available_for_trade": "Für Trades verfügbar",
  "free_balance_after": "Freies Guthaben danach",
  "tab_major": "Hauptwerte",
  "tab_shitcoins": "Shitcoins",
  "tab_nfts": "NFTs",
  "filter_direction": "Richtung",
  "buy_only": "Nur Kauf",
  "sell_only": "Nur Verkauf",
  "min_confidence": "Min. Konfidenz",
  "confirm": "Bestätigen",
  "safety_score": "Sicherheits-Score",
  "liquidity_lock": "Liquiditätssperre",
  "locked": "Gesperrt",
  "unlocked": "Entsperrt",
  "honeypot": "Honeypot",
  "honeypot_safe_label": "Sicher",
  "honeypot_risk": "Risiko",
  "nft_demo_notice": "Demo-Trade — es wird kein echtes NFT gekauft",
  "view_on_opensea": "Auf OpenSea ansehen",
  "volume_24h": "Volumen (24 Std.)",
  "nft_position_opened": "NFT-Position eröffnet (Demo)",
  "crypto_positions_title": "Krypto- & Shitcoin-Positionen",
  "nft_positions_title": "NFT-Positionen",
  "min_safety_required": "Der Sicherheits-Score muss ≥ 75 sein, um zu handeln",
  "amount_exceeds_balance": "Der Betrag übersteigt dein freies Guthaben",
  "amount_gt_zero": "Der Betrag muss größer als 0 sein",
  "confirm_trade": "Trade bestätigen",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "Keine offenen NFT-Positionen",
  "floor": "Mindestpreis",
  "rr_short": "C:R",
  "best_marketplace": "Bester Markt",
  "story": "Geschichte",
  "show_more": "Mehr anzeigen",
  "show_less": "Weniger anzeigen",
  "view_chart": "Chart ansehen",
  "reason_sma_bull": "SMA9 über SMA21 (bullischer Trend)",
  "reason_sma_bear": "SMA9 unter SMA21 (bärischer Trend)",
  "reason_rsi_oversold": "überverkauft",
  "reason_rsi_overbought": "überkauft",
  "reason_rsi_neutral": "neutral",
  "reason_pos_momentum": "Positives Momentum",
  "reason_neg_momentum": "Negatives Momentum",
  "reason_insufficient": "Unzureichende Daten",
  "reason_whale_accum": "Wal-Akkumulation",
  "reason_rising_floor": "Steigender Floor",
  "reason_falling_floor": "Fallender Floor",
  "reason_high_rarity": "Hohe Seltenheit",
  "reason_mid_rarity": "Mittlere Seltenheit",
  "nft_trade_history": "NFT-Handelsverlauf",
  "no_nft_trades": "Noch keine abgeschlossenen NFT-Trades",
  "entry_floor": "Einstiegs-Floor",
  "exit_floor": "Ausstiegs-Floor",
  "verify_reminder": "Deine E-Mail ist noch nicht verifiziert — verifiziere sie, um den Handel freizuschalten.",
  "verify_now": "Jetzt verifizieren",
  "dismiss": "Schließen",
  "trusted_devices": "Aktive Sitzungen · Angemeldete Geräte",
  "font_size": "Schriftgröße",
  "font_small": "Klein",
  "font_medium": "Mittel",
  "font_large": "Groß",
  "sessions_hint": "Smartphones und Browser, die aktuell in deinem Konto angemeldet sind (keine Börsen-API-Schlüssel).",
  "unknown_device": "Unbekanntes Gerät",
  "this_device": "Dieses Gerät",
  "current_session": "Aktuell",
  "last_active": "Zuletzt aktiv",
  "revoke_all_others": "Alle anderen Geräte abmelden",
  "revoke_all_others_done": "Von allen anderen Geräten abgemeldet",
  "no_other_devices": "Keine anderen aktiven Geräte",
  "device_revoked": "Gerät abgemeldet",
  "ui_logo_alt": "Firebird / Simorgh Trade-Logo",
  "ui_logo_switch_hint": "Tippen, um das Logo zu wechseln",
  "ui_vpn_info": "VPN-Informationen"
};
export default de;
